export function handleNav() {
    const mql = window.matchMedia("(max-width: 1449px)");
    const trigger = document.querySelector("[data-nav-trigger]");
    const items = document.querySelectorAll("[data-nav-item]");

    function changeClass() {
        const nav = document.querySelector("[data-nav]");
        const wrapper = document.querySelector("[data-wrapper]");
        const body = document.querySelector("body");

        trigger.classList.toggle("-open");
        nav.classList.toggle("-open");
        wrapper.classList.toggle("-open");
        body.classList.toggle("-lock");
        body.classList.toggle("-opennav");
    }

    function setCurrentClass() {
        const currentUrl = window.location.href;
        for (const item of Array.from(items)) {
            const link = item.querySelector("a");
            if (link) {
                if (link.href === currentUrl) {
                    item.classList.add("-current");
                } else {
                    item.classList.remove("-current");
                }
            }
        }
    }

    function init() {
        if (mql.matches) {
            trigger.addEventListener("click", changeClass);
            for (const item of Array.from(items)) {
                item.addEventListener("click", changeClass);
            }
        } else {
            setCurrentClass();
            window.addEventListener("hashchange", setCurrentClass);

            if (document.body.classList.contains("-opennav")) {
                const nav = document.querySelector("[data-nav]");
                const wrapper = document.querySelector("[data-wrapper]");

                trigger.classList.remove("-open");
                nav.classList.remove("-open");
                wrapper.classList.remove("-open");
                document.body.classList.remove("-lock");
                document.body.classList.remove("-opennav");
            }
        }
    }

    init();
    mql.addEventListener("change", init);
}
